export default "__VITE_ASSET__DTwixm29__"